import(/* webpackMode: "eager", webpackExports: ["LoadingIndicator"] */ "/opt/buildhome/repo/packages/ui/dist/index.mjs");
